import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { RelatorioSpnvFiltroService } from './relatorio-spnv-filtro.service';
import { RelatorioSpnvComponent } from './relatorio-spnv.component';
import { RelatorioSpnvService } from './relatorio-spnv.service';

@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TableModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    MultiSelectModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TooltipModule,
    ProgressSpinnerModule,
  ],
  exports: [RelatorioSpnvComponent],
  declarations: [RelatorioSpnvComponent],
  providers: [RelatorioSpnvService, RelatorioSpnvFiltroService, DatePipe],
})
export class RelatorioSpnvModule { }
